import axios from "axios";

export const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("piq_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d.message) {
    const extra = (d.lint || []).map((l) => l.message).concat(d.illustrations || [], d.missing || []);
    return [d.message, ...extra.slice(0, 6)].join(" · ");
  }
  return JSON.stringify(d);
}

export function getPath(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
}

export function setPath(obj, path, value) {
  const keys = path.split(".");
  let o = obj;
  keys.slice(0, -1).forEach((k, i) => {
    const nextIsIdx = /^\d+$/.test(keys[i + 1]);
    if (o[k] == null) o[k] = nextIsIdx ? [] : {};
    o = o[k];
  });
  const last = keys[keys.length - 1];
  if (value === null && Array.isArray(o) && /^\d+$/.test(last)) o.splice(Number(last), 1);
  else o[last] = value;
  return obj;
}

export async function fetchPdfUrl(path, opts = {}) {
  const r = await api.request({ url: path, responseType: "blob", ...opts });
  return { url: URL.createObjectURL(r.data), sha: r.headers["x-pdf-sha256"] };
}

export const MODES = { at_home: "At-home", remote: "Remote", hybrid: "Hybrid", clinic: "Clinic/Hospital", in_plant: "In-plant" };
export const LANGS = { en: "English", ta: "Tamil", hi: "Hindi", ms: "Malay" };
export const MARKETS = { IN: "India", MY: "Malaysia" };
export const ROLES = ["admin", "author", "reviewer", "approver", "publisher", "consumer"];
export const ROLE_LABEL = { admin: "Admin", author: "Clinical Author", reviewer: "Clinical Reviewer", approver: "Clinical Approver", publisher: "Publisher", consumer: "Read-only (portal)" };
export const PERMS = {
  admin: ["*"], author: ["author", "ai", "comment", "illustrate"], reviewer: ["review", "comment", "verify_illustration"],
  approver: ["approve", "comment", "verify_illustration"], publisher: ["publish", "retire", "comment"], consumer: [],
};
export const can = (user, action) => !!user && (PERMS[user.role]?.includes("*") || PERMS[user.role]?.includes(action));
export const SPECIALTIES = ["ortho", "neuro", "post-op", "sports", "geriatric", "cardio-pulmonary", "women's health", "paediatric", "workplace/MSK"];
